export function formatNumberWithSeparators(value?: string | number | null) {
  if (value == null || value === '') return '';
  const digits = String(value).replace(/[^\d]/g, '');
  if (!digits) return '';
  return new Intl.NumberFormat('en-US').format(Number(digits));
}

export function stripNumberSeparators(value: string) {
  return value.replace(/[^\d]/g, '');
}

export function centsToGoalString(cents: number | null | undefined): string {
  if (cents == null) return '';
  return formatNumberWithSeparators(Math.round(cents / 100));
}

export function goalStringToCents(value: string): number | null {
  const digits = stripNumberSeparators(value);
  if (!digits) return null;
  return Number(digits) * 100;
}

export function formatMoneyLabel(value?: string | number | null): string {
  const formatted =
    typeof value === 'number'
      ? formatNumberWithSeparators(value)
      : value?.trim()
        ? value
        : '';
  if (!formatted) return '—';
  return `$${formatted}`;
}
